<template>
  <div class="lp-container">
    <FirstView012 />
    <RankingTable012 />
    <CvCardKansai01 />
    <IntroDuction009 />
    <SelectionCriteria012 />
    <VendorRankingTitle012 />
    <VendorDetail012 />
    <EstimateSection />
    <CvCardKansai02 />
    <InquiryFlow />
    <QuestionAnswer12 />
    <RankingTableSummary012 />
  </div>
</template>

<script setup>
import FirstView012 from '@/components/header/FirstView012.vue'
import IntroDuction009 from '@/components/intro/IntroDuction009.vue'
import CvCardKansai01 from '@/components/cv/CvCardKansai01.vue'
import CvCardKansai02 from '@/components/cv/CvCardKansai02.vue'
import SelectionCriteria012 from '@/components/criterion/SelectionCriteria012.vue'
import VendorDetail012 from '@/components/vendor/VendorDetail012.vue'
import QuestionAnswer12 from '@/components/question/QuestionAnswer12.vue'
import VendorRankingTitle012 from '@/components/ranking/VendorRankingTitle012.vue'
import RankingTable012 from '@/components/ranking/RankingTable012.vue'
import InquiryFlow from '@/components/flow/InquiryFlow.vue'
import EstimateSection from '@/components/cv/EstimateSection.vue'
import RankingTableSummary012 from '@/components/ranking/RankingTableSummary012.vue'

</script>

<style scoped>
.lp-container {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  background-color: white;
  min-height: 100dvh;
  height: auto;
}

.double-circle {
  width: 40px;
  height: 40px;
  position: relative;
  border: solid #fa8072 5px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
}

.double-circle::before {
  content: "";
  width: 25px;
  height: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: solid #fa8072 5px;
  border-radius: 50%;
  box-sizing: border-box;
}

.cross {
  position: relative;
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.cross::before,
.cross::after {
  content: "";
  position: absolute;
  top: 18px;
  left: -4px;
  width: 40px;
  height: 6px;
  background: #607d8b;
}

.cross::before {
  transform: rotate(45deg);
}

.cross::after {
  transform: rotate(-45deg);
}

.circle {
  width: 30px;
  height: 30px;
  border: 6px solid #409fca;
  border-radius: 50%;
  margin: 0 auto;
}

.triangle {
  --b: 12px;
  width: 50px;
  aspect-ratio: 1/cos(30deg);
  clip-path: polygon(50% 0, 100% 100%, 0 100%, 50% 0, 50% var(--b), calc(var(--b)*cos(30deg)) calc(100% - var(--b)/2), calc(100% - var(--b)*cos(30deg)) calc(100% - var(--b)/2), 50% var(--b));
  background: #ffc107;
  margin: 0 auto;
}

.bold-red {
  color: #e74c3c;
  font-weight: bold;
}

.under-yellow {
  background: linear-gradient(transparent 65%, rgb(253 233 61) 50%);
  font-weight: 600;
}

.bold-font {
  font-weight: 600;
}
</style>
